export default {
  color: {
    white: '#FFFFFF',
    orange: '#FF8300',
    lightOrange: '#FFA340',
    blue: '#118DF5',
    darkBlue: '#1A63B6',
    green: '#2ACEAA',
    red: '#FF4D4F',
    yellow: '#F7C95C',
    grey: '#4B5161',
    //text
    dark: '#0E162C',
    mediumDark: '#878B96',
    lightDark: '#BCC2D2',
    //icon
    iconDark: '#4B5161',
    iconlightDark: '#BCC2D2',
    // dividers and backgrounds
    lightGrey1: '#DEE1E9',
    lightGrey2: '#EFF0F4',
  },
}
